import {useUserLoggedIn} from "./useUserLoggedIn";
import {useQuery} from '@tanstack/react-query';
import {useCountryLang} from "./useCountryLang";
import {ICart} from "../interfaces/ICart";
import {request} from "../shared/httpInterceptor";
import {useAtom} from "jotai";
import {nextSessionAtom} from "../store/sessionAtom";

export const fetchShoppingCart = async (countryLang: string | null, deliveryCountry: string | null | undefined,
                                        session: any, host?: string, cookies?: any) => {
  const res = await request({
    url: `/${countryLang}/shoppingCart`,
    data: {
      deliveryCountry: deliveryCountry ? deliveryCountry : null
    },
    method: 'post',
    session: session,
    host: host,
    cookies: cookies
  })
  return res.data;
}

export const useShoppingCart = () => {
  const isUserLoggedIn = useUserLoggedIn();
  const countryLang = useCountryLang();
  const [sessionAtom] = useAtom(nextSessionAtom)
  const {session, status} = sessionAtom;
  return useQuery<ICart>(["shopping-cart", countryLang], () => fetchShoppingCart(countryLang, null, session), {
    enabled: isUserLoggedIn && countryLang!=null
  })
}
